export const lightTheme = {
  background: "#FAFAFA",
  text: "#2E2E2E",
  primary: "#4f9fca",
  headerBackground: "#FAFAFA", // Nuovo colore per l'header
  headerText: "#2E2E2E", // Colore del testo nell'header
  primaryDark: "#2A75E6",
  secondary: "#FFBE0B",
  accent: "#FF006E",
  border: "#E0E0E0",
  inputBackground: "#FFFFFF",
  accent: "#ff6b6b",
  accentHover: "#ff5252",
  primaryHover: "#2a75e6",
  calculateButton: "#4f9fca",
  calculateButtonText: "#FFFFFF",
  shadowColor: "rgba(0, 0, 0, 0.1)",
  nicotineButtonBackground: "#E0E0E0",
  nicotineButtonText: "#333333",
  nicotineButtonActiveBackground: "#4f9fca",
  nicotineButtonActiveText: "#FFFFFF",
  tooltipBackground: "#333",
  tooltipText: "#fff",
};

export const darkTheme = {
  background: "#1A1A1A",
  text: "#E4E4E4",
  primary: "#3A86FF",
  primaryDark: "#2A75E6",
  secondary: "#FFBE0B",
  accent: "#FF006E",
  border: "#333333",
  inputBackground: "#2C2C2C",
  accent: "#ff6b6b",
  accentHover: "#ff5252",
  primaryHover: "#5a9cff",
  calculateButton: "#FFA500", // Arancione
  calculateButtonText: "#000000",
  shadowColor: "rgba(255, 255, 255, 0.1)",
  nicotineButtonBackground: "#333333",
  nicotineButtonText: "#FFFFFF",
  nicotineButtonActiveBackground: "#3A86FF",
  nicotineButtonActiveText: "#FFFFFF",
  tooltipBackground: "#333",
  tooltipText: "#fff",
};
